import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

import { IAmpProps } from '../../typings/amp';
import t from '../../labels/labelling-utils';

export interface IAmpVideoProps extends IAmpProps, DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  className?: string;
  videoPageUrl?: string;
}

// We return a link to the video-page as we cannot inject the <amp-video-iframe> tag due to some issues on BE & AEM side
const AmpVideo: React.FC<IAmpVideoProps> = ({ className = '', videoPageUrl = '' }) => (
  <div className={className}>
    <a href={videoPageUrl}>{t('post.video.go.to.video')}</a>
  </div>
);

export default AmpVideo;
